export function Logo({ inverse = false }: { inverse?: boolean }) {
  return (
    <a className={`logo${inverse ? ' logo--inverse' : ''}`} href="#top" aria-label="BISEN home">
      <span className="logo-mark" aria-hidden="true">
        <span>B</span>
      </span>
      <span className="logo-word">BISEN</span>
      <span className="logo-slash" aria-hidden="true" />
    </a>
  )
}
